module.exports = __webpack_public_path__ + "static/media/icon-warning-red.c2c3ba7b.svg";